const GET_COMPANY_CONFIG = 'usuarios/myCompany/GET_COMPANY_CONFIG';
const GET_COMPANY_CONFIG_COMPLETED = 'usuarios/myCompany/GET_COMPANY_CONFIG_COMPLETED';
const GET_COMPANY_CONFIG_FAILED = 'usuarios/myCompany/GET_COMPANY_CONFIG_FAILED';

const GET_COMPANY_DATA = 'usuarios/myCompany/GET_COMPANY_DATA';
const GET_COMPANY_DATA_COMPLETED = 'usuarios/myCompany/GET_COMPANY_DATA_COMPLETED';
const GET_COMPANY_DATA_FAILED = 'usuarios/myCompany/GET_COMPANY_DATA_FAILED';

const GET_COMPANY_USERS = 'usuarios/myCompany/GET_COMPANY_USERS';
const GET_COMPANY_USERS_COMPLETED = 'usuarios/myCompany/GET_COMPANY_USERS_COMPLETED';
const GET_COMPANY_USERS_FAILED = 'usuarios/myCompany/GET_COMPANY_USERS_FAILED';

const PASSWORD_COMPANY_USERS = 'usuarios/myCompany/PASSWORD_COMPANY_USERS';
const PASSWORD_COMPANY_USERS_COMPLETED = 'usuarios/myCompany/PASSWORD_COMPANY_USERS_COMPLETED';
const PASSWORD_COMPANY_USERS_FAILED = 'usuarios/myCompany/PASSWORD_COMPANY_USERS_FAILED';

const PUT_COMPANY_PUBR = 'usuarios/myCompany/PUT_COMPANY_PUBR';
const PUT_COMPANY_PUBR_COMPLETED = 'usuarios/myCompany/PUT_COMPANY_PUBR_COMPLETED';
const PUT_COMPANY_PUBR_FAILED = 'usuarios/myCompany/PUT_COMPANY_PUBR_FAILED';
const RESET_COMPANY_PUBR = 'usuarios/myCompany/RESET_PUBLISHER_PUBR';

const GET_AUTOLOGIN = 'usuarios/myCompany/GET_AUTOLOGIN';
const GET_AUTOLOGIN_COMPLETED = 'usuarios/myCompany/GET_AUTOLOGIN_COMPLETED';
const GET_AUTOLOGIN_FAILED = 'usuarios/myCompany/GET_AUTOLOGIN_FAILED';

const GET_AGENT_DATA = 'usuarios/myCompany/GET_AGENT_DATA';
const GET_AGENT_DATA_COMPLETED = 'usuarios/myCompany/GET_AGENT_DATA_COMPLETED';
const GET_AGENT_DATA_FAILED = 'usuarios/myCompany/GET_AGENT_DATA_FAILED';

const GET_BRANCHES = 'usuarios/myCompany/GET_BRANCHES';
const GET_BRANCHES_COMPLETED = 'usuarios/myCompany/GET_BRANCHES_COMPLETED';
const GET_BRANCHES_FAILED = 'usuarios/myCompany/GET_BRANCHES_FAILED';

const POST_BRANCHES_DEACTIVATE = 'usuarios/myCompany/POST_BRANCHES_DEACTIVATE';
const POST_BRANCHES_DEACTIVATE_COMPLETED = 'usuarios/myCompany/POST_BRANCHES_DEACTIVATE_COMPLETED';
const POST_BRANCHES_DEACTIVATE_FAILED = 'usuarios/myCompany/POST_BRANCHES_DEACTIVATE_FAILED';

const SET_COMMISSION_SHARE = 'usuarios/myCompany/SET_COMMISSION_SHARE';
const SET_COMMISSION_SHARE_COMPLETED = 'usuarios/myCompany/SET_COMMISSION_SHARE_COMPLETED';
const SET_COMMISSION_SHARE_FAILED = 'usuarios/myCompany/SET_COMMISSION_SHARE_FAILED';

const GET_COMMISSION_SHARE = 'usuarios/myCompany/GET_COMMISSION_SHARE';
const GET_COMMISSION_SHARE_COMPLETED = 'usuarios/myCompany/GET_COMMISSION_SHARE_COMPLETED';
const GET_COMMISSION_SHARE_FAILED = 'usuarios/myCompany/GET_COMMISSION_SHARE_FAILED';

const DELETE_COMMISSION_SHARE = 'usuarios/myCompany/DELETE_COMMISSION_SHARE';
const DELETE_COMMISSION_SHARE_COMPLETED = 'usuarios/myCompany/DELETE_COMMISSION_SHARE_COMPLETED';
const DELETE_COMMISSION_SHARE_FAILED = 'usuarios/myCompany/DELETE_COMMISSION_SHARE_FAILED';

const PUT_BRANCHES_ACTIVATE = 'usuarios/myCompany/PUT_BRANCHES_ACTIVATE';
const PUT_BRANCHES_ACTIVATE_COMPLETED = 'usuarios/myCompany/PUT_BRANCHES_ACTIVATE_COMPLETED';
const PUT_BRANCHES_ACTIVATE_FAILED = 'usuarios/myCompany/PUT_BRANCHES_ACTIVATE_FAILED';

const RESET_DEACTIVATE = 'usuarios/myCompany/RESET_DEACTIVATE';
const RESET_USER_PASSWORD = 'usuarios/myCompany/RESET_USER_PASSWORD';

export {
  GET_COMPANY_CONFIG,
  GET_COMPANY_CONFIG_COMPLETED,
  GET_COMPANY_CONFIG_FAILED,
  GET_COMPANY_DATA,
  GET_COMPANY_DATA_COMPLETED,
  GET_COMPANY_DATA_FAILED,
  GET_COMPANY_USERS,
  GET_COMPANY_USERS_COMPLETED,
  GET_COMPANY_USERS_FAILED,
  PASSWORD_COMPANY_USERS,
  PASSWORD_COMPANY_USERS_COMPLETED,
  PASSWORD_COMPANY_USERS_FAILED,
  PUT_COMPANY_PUBR,
  PUT_COMPANY_PUBR_COMPLETED,
  PUT_COMPANY_PUBR_FAILED,
  RESET_COMPANY_PUBR,
  GET_AUTOLOGIN,
  GET_AUTOLOGIN_COMPLETED,
  GET_AUTOLOGIN_FAILED,
  GET_AGENT_DATA,
  GET_AGENT_DATA_COMPLETED,
  GET_AGENT_DATA_FAILED,
  GET_BRANCHES,
  GET_BRANCHES_COMPLETED,
  GET_BRANCHES_FAILED,
  POST_BRANCHES_DEACTIVATE,
  POST_BRANCHES_DEACTIVATE_COMPLETED,
  POST_BRANCHES_DEACTIVATE_FAILED,
  PUT_BRANCHES_ACTIVATE,
  PUT_BRANCHES_ACTIVATE_COMPLETED,
  PUT_BRANCHES_ACTIVATE_FAILED,
  RESET_DEACTIVATE,
  RESET_USER_PASSWORD,
  SET_COMMISSION_SHARE,
  SET_COMMISSION_SHARE_COMPLETED,
  SET_COMMISSION_SHARE_FAILED,
  GET_COMMISSION_SHARE,
  GET_COMMISSION_SHARE_COMPLETED,
  GET_COMMISSION_SHARE_FAILED,
  DELETE_COMMISSION_SHARE,
  DELETE_COMMISSION_SHARE_COMPLETED,
  DELETE_COMMISSION_SHARE_FAILED
};
